import React from "react";
import { Section, Toggle, Badge } from "../shared";
import SpendingDashboard from "../Config/SpendingDashboard";

const QUICK_FEATURES = [
  { id: "send_native", label: "Send native tokens" },
  { id: "send_token", label: "Send ERC-20 tokens" },
  { id: "contract_read", label: "Read smart contracts" },
];

export default function OverviewSection({
  config,
  spending,
  onConfigUpdate,
  onGoToAdvanced,
}) {
  if (!config) return null;

  const enabled = config.enabled ?? true;

  const handleMasterToggle = () => {
    onConfigUpdate(
      (prev) => ({ enabled: !prev.enabled }),
      { mcp_enabled: !enabled }
    );
  };

  const handleFeatureToggle = (featureId, val) => {
    onConfigUpdate(
      (prev) => ({ features: { ...prev.features, [featureId]: val } }),
      { features: { [featureId]: val } }
    );
  };

  return (
    <Section
      title="Quick Settings"
      subtitle="Overview of your AI agent configuration"
      id="mcp-overview"
    >
      {/* Master toggle */}
      <div className="mcp-master-toggle">
        <div className="mcp-master-toggle-info">
          <h4 className="mcp-master-toggle-title">AI agent access</h4>
          <Badge variant={enabled ? "green" : "red"}>
            {enabled ? "Active" : "Disabled"}
          </Badge>
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={enabled}
          className={`mcp-toggle mcp-toggle-lg ${
            enabled ? "mcp-toggle-on" : "mcp-toggle-off"
          }`}
          onClick={handleMasterToggle}
        >
          <span className="mcp-toggle-knob" />
        </button>
      </div>

      {/* Spending summary */}
      <SpendingDashboard spending={spending} disabled={!enabled} />

      {/* Quick feature toggles */}
      <div className={!enabled ? "mcp-disabled-section" : ""}>
        <h5 className="mcp-subsection-title">Quick features</h5>
        {QUICK_FEATURES.map((feat) => (
          <Toggle
            key={feat.id}
            label={feat.label}
            checked={config.features?.[feat.id] ?? false}
            onChange={(val) => handleFeatureToggle(feat.id, val)}
            disabled={!enabled}
          />
        ))}
        <button
          type="button"
          className="mcp-link-btn"
          onClick={onGoToAdvanced}
        >
          More settings &rarr;
        </button>
      </div>
    </Section>
  );
}
